import React, { Suspense, lazy, useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LiveBettingTicker from './components/LiveBettingTicker';
import FloatingCTA from './components/FloatingCTA';
import SoundToggle from './components/SoundToggle';
import useGameSound from './hooks/useGameSound';
import ParticleBackground from './components/ParticleBackground';

const Home = lazy(() => import('./pages/Home'));
const Games = lazy(() => import('./pages/Games'));
const Download = lazy(() => import('./pages/Download'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Contact = lazy(() => import('./pages/Contact'));
const LiveMatches = lazy(() => import('./pages/LiveMatches'));
const Roulette = lazy(() => import('./pages/testRoulette'));

function App() {

    const {
    isMuted,
    toggleSound,
    audioReady,
    loadError,
    currentTrack,
    totalTracks,
    skipTrack
  } = useGameSound();

  const [showPrompt, setShowPrompt] = useState(true);

  const handleEnableSound = () => {
    toggleSound(); // Unmute and play
    setShowPrompt(false);
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  return (
    <Router>
      <div className="bg-[#0a0a0f] min-h-screen text-white overflow-x-hidden">
        <ParticleBackground />
        <LiveBettingTicker />
        <Navbar />
        <Suspense fallback={
          <div className="fixed inset-0 bg-[#0a0a0f] flex items-center justify-center z-50">
            <div className="relative">
              <div className="w-20 h-20 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-2xl">🎰</span>
              </div>
            </div>
          </div>
        }>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/games" element={<Games />} />
              <Route path="/live" element={<LiveMatches />} />
              <Route path="/download" element={<Download />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path='/roulette' element={<Roulette />}/>
            </Routes>
          </AnimatePresence>
        </Suspense>
        <Footer />
        <ScrollToTop />
        <FloatingCTA />
        <SoundToggle
          isMuted={isMuted}
          onToggle={toggleSound}
          currentTrack={currentTrack}
          totalTracks={totalTracks}
          onSkipTrack={skipTrack}
        />
      </div>
    </Router>
  );
}

export default App;